import { createReducer, DEFAULT_CONSENTS, TrackingConsents } from '@mews/framework';
import { UPDATE_CONSENTS } from './actions';

export const trackingConsentReducer = createReducer(DEFAULT_CONSENTS, {
    [UPDATE_CONSENTS]: (state: TrackingConsents, consents: TrackingConsents) => consents,
});
